import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row, Col, Form} from "react-bootstrap";

const ProfileArea = () => {
    const { t } = useTranslation();
    const currentUser = useSelector((state) => state.auth.user);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        return d.toLocaleDateString();
    };

console.log(currentUser);
    return (
        <div className="pt-3">
            <div className="mb-5">
                <h3 className="txt-main fw-bold mb-1">{t('components.ProfileArea.profile_info')}</h3>
                <p className="txt-subtle mb-4" style={{ fontSize: '0.9rem' }}>{t('components.ProfileArea.profile_info_desc')}</p>
                <Form>
                    <Row className="mb-3 g-4">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.email')}</Form.Label>
                                <Form.Control type="email" value={currentUser.email || ""} readOnly className="bg-surface txt-main" />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.role')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={currentUser.role?.name || currentUser.role_id || ""} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.delegation')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={currentUser.delegation?.name || currentUser.delegation_id || ""} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3 g-4">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.employment_type')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={currentUser.employment_type || ""} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.position')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={currentUser.position || ""} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.team')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={currentUser.team_tag || ""} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3 g-4">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.hiring_date')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={formatDate(currentUser.hiring_date)} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.seniority_level')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={currentUser.seniority_level || ""} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="txt-subtle fw-semibold" style={{ fontSize: '0.85rem' }}>{t('components.ProfileArea.manager')}</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={currentUser.manager?.username || currentUser.manager?.name || currentUser.manager_id || ""} 
                                    readOnly 
                                    className="bg-surface txt-main" 
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                </Form>
            </div>
        </div>
    );
}

export default ProfileArea;